import React from "react";
import styled from "styled-components";

import { getConfig } from "../../../../../../utils/config";
import { getCookieByName } from "../../../../../../utils";

const config = getConfig();

const colors = config.theme.colors;

const header = config.theme.navbar.header;

const NavHeader = styled.li`
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 0px;
  background-color: ${header.backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CompanyBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
`;

const CompanyIcon = styled.div`
  width: 48px;
  height: 48px;
  background: linear-gradient(100deg, ${colors.primary}, ${colors.secondary});
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  font-size: 20px;
  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.1),
    0 2px 6px rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
`;
const CompanyName = styled.div`
  font-size: 13px;
  font-weight: bold;
  color: ${colors.white};
`;

const Username = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${colors.white};
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  line-height: 1.4;

  i.user-icon {
    color: #90caf9;
    font-size: 14px;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${colors.primary};
  margin: 20px 0;
`;
const EditIcon = styled.i`
  color: #b0bec5;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #ffffff;
  }
`;

export default function (props) {
  const ref = React.useRef(null);
  const [data, setData] = React.useState({ companyName: "", username: "" });


  React.useEffect(() => {
    setData({
      companyName: getCookieByName("branch_owner_name"),
      username: getCookieByName("username"),
    });
  }, [ref.current]);

  return (
    <NavHeader ref={ref}>
      <CompanyBox>
        <CompanyIcon>
          <i className="fas fa-building" />
        </CompanyIcon>
        <CompanyName>{data.companyName}</CompanyName>
        <Username>
          <i className="fas fa-user user-icon" />
          {data.username}
          <EditIcon
            className="fas fa-edit"
            title="Editar perfil"
            onClick={() => (window.location.href = "/profile")}
          />
        </Username>
      </CompanyBox>
      <Divider />
    </NavHeader>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/SideArea/SideHeader/index.jsx